import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthConsumer } from "./AuthProvider";

export const Callback = () => (
    <AuthConsumer>
        {({ signinRedirectCallback }) => {
            signinRedirectCallback();
            return <AbpnSpinner/>;
        }}
    </AuthConsumer>
);